document.documentElement.classList.remove('no-js');
const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
$$('[data-mobile-toggle]').forEach(b=>b.addEventListener('click',()=>$('.mobile-menu')?.classList.toggle('open')));
const drawer=$('[data-cart-drawer]'), backdrop=$('.drawer-backdrop');
function drawerState(open){drawer?.classList.toggle('open',open);backdrop?.classList.toggle('open',open);drawer?.setAttribute('aria-hidden',String(!open));}
$$('[data-cart-open]').forEach(b=>b.addEventListener('click',()=>drawerState(true)));$$('[data-drawer-close]').forEach(b=>b.addEventListener('click',()=>drawerState(false)));
$$('[data-product-root]').forEach(root=>{const variants=JSON.parse($('[data-variants-json]',root)?.textContent||'[]');const select=$('select[name="id"]',root);const price=$('[data-product-price]',root);const button=$('[name="add"]',root);const groups=$$('[data-option-index]',root);function update(){const chosen=groups.map(g=>$('.option-pill.active',g)?.dataset.value);const v=variants.find(x=>x.options.every((o,i)=>o===chosen[i]));if(v&&select){select.value=v.id;price.textContent=(v.price/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify?.currency?.active||'GBP'});button.disabled=!v.available;button.textContent=v.available?'Add to cart':'Sold out';}else if(button){button.disabled=true;button.textContent='Choose your fitment';}}groups.forEach(g=>$$('.option-pill',g).forEach(p=>p.addEventListener('click',()=>{$$('.option-pill',g).forEach(x=>x.classList.remove('active'));p.classList.add('active');update()})));update();});
$$('[data-ajax-product-form]').forEach(form=>form.addEventListener('submit',async e=>{e.preventDefault();const btn=$('[name="add"]',form);if(btn?.disabled)return;btn.textContent='Adding…';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});if(!r.ok)throw new Error();drawerState(true);const c=await fetch('/cart.js').then(x=>x.json());$('[data-cart-count]')?.replaceChildren(document.createTextNode(c.item_count));document.dispatchEvent(new CustomEvent('sette:cart-updated'));$('[data-cart-drawer-content]').innerHTML=`<p><strong>${c.item_count} item${c.item_count===1?'':'s'}</strong> added to your build.</p><p class="muted">Subtotal: ${(c.total_price/100).toLocaleString(undefined,{style:'currency',currency:c.currency})}</p>`;}catch(err){alert('Could not add this item. Please try again.');}finally{btn.textContent='Add to cart';}}));
// Reveal desktop navigation when the user scrolls upward; hide it while scrolling down.
(() => {
  const header = document.querySelector('[data-smart-header]');
  if (!header) return;
  let lastY = window.scrollY;
  let ticking = false;
  let hideTimer;

  const reveal = () => {
    clearTimeout(hideTimer);
    header.classList.add('nav-revealed');
  };

  const hide = () => {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => header.classList.remove('nav-revealed'), 120);
  };

  const updateHeader = () => {
    const currentY = window.scrollY;
    const delta = currentY - lastY;

    if (window.innerWidth > 950) {
      if (currentY < 20) {
        header.classList.remove('nav-revealed');
      } else if (delta < -8) {
        reveal();
      } else if (delta > 10) {
        hide();
      }
    }

    lastY = currentY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();


// SETTE MOTION v4: loader, page transitions, reveals, parallax and reactive lighting.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loader = document.querySelector('[data-sette-loader]');
  const hideLoader = () => loader?.classList.add('is-hidden');
  if (document.readyState === 'complete') setTimeout(hideLoader, 180);
  else window.addEventListener('load', () => setTimeout(hideLoader, 260), { once: true });
  setTimeout(hideLoader, 2200);

  if (!reduceMotion) {
    document.querySelectorAll('a[href]').forEach(link => {
      link.addEventListener('click', event => {
        const url = new URL(link.href, location.href);
        const sameOrigin = url.origin === location.origin;
        const normalClick = !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && link.target !== '_blank';
        if (!sameOrigin || !normalClick || url.hash || link.hasAttribute('download') || link.dataset.cartOpen !== undefined) return;
        event.preventDefault();
        document.body.classList.add('sette-page-exit');
        setTimeout(() => location.href = url.href, 260);
      });
    });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach(item => observer.observe(item));
  } else revealItems.forEach(item => item.classList.add('is-revealed'));

  const parallaxRoots = [...document.querySelectorAll('[data-parallax-root]')];
  let parallaxTicking = false;
  const parallaxUpdate = () => {
    const vh = window.innerHeight;
    parallaxRoots.forEach(root => {
      const rect = root.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      const progress = (vh - rect.top) / (vh + rect.height);
      const media = root.querySelector('[data-parallax-media]');
      const content = root.querySelector('[data-reveal-content]');
      media?.style.setProperty('--parallax-y', `${(progress - .5) * 46}px`);
      content?.style.setProperty('--hero-content-y', `${(progress - .5) * -22}px`);
    });
    parallaxTicking = false;
  };
  if (!reduceMotion) window.addEventListener('scroll', () => {
    if (!parallaxTicking) { requestAnimationFrame(parallaxUpdate); parallaxTicking = true; }
  }, { passive: true });
  parallaxUpdate();

  if (window.matchMedia('(hover:hover)').matches && !reduceMotion) {
    document.querySelectorAll('[data-reactive-card]').forEach(card => {
      card.addEventListener('pointermove', e => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left, y = e.clientY - rect.top;
        const px = x / rect.width, py = y / rect.height;
        card.style.setProperty('--mx', `${px * 100}%`);
        card.style.setProperty('--my', `${py * 100}%`);
        card.style.setProperty('--ry', `${(px - .5) * 5}deg`);
        card.style.setProperty('--rx', `${(.5 - py) * 4}deg`);
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
      });
    });
  }
})();

// SETTE v4.3: reliably start cinematic hero videos, including inside Shopify theme editor.
(() => {
  const startHeroVideos = (root = document) => {
    root.querySelectorAll?.('[data-hero-video]').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const attempt = () => {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };
      if (video.readyState >= 2) attempt();
      else {
        video.addEventListener('loadeddata', attempt, { once: true });
        video.addEventListener('canplay', attempt, { once: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => startHeroVideos());
  else startHeroVideos();
  window.addEventListener('load', () => startHeroVideos());
  document.addEventListener('shopify:section:load', event => startHeroVideos(event.target));
  document.addEventListener('shopify:section:select', event => startHeroVideos(event.target));
})();

// SETTE v5: make newly selected images/videos visible immediately in the Shopify editor.
(() => {
  const activateMedia = (root = document) => {
    root.querySelectorAll?.('video').forEach(video => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      if (video.hasAttribute('autoplay')) {
        const play = () => video.play().catch(() => {});
        if (video.readyState >= 2) play();
        else video.addEventListener('canplay', play, { once:true });
      }
    });
    root.querySelectorAll?.('[data-reveal]').forEach(el => el.classList.add('is-revealed'));
  };
  document.addEventListener('shopify:section:load', e => activateMedia(e.target));
  document.addEventListener('shopify:section:select', e => activateMedia(e.target));
  document.addEventListener('shopify:block:select', e => activateMedia(e.target));
  if (document.documentElement.classList.contains('shopify-design-mode') || window.Shopify?.designMode) activateMedia();
})();


// SETTE v6 launch commerce utilities
(() => {
  const money = (p,c='GBP') => (p/100).toLocaleString(undefined,{style:'currency',currency:c});
  const wishlistKey='sette_saved_build';
  const getSaved=()=>{try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]')}catch{return[]}};
  const setSaved=x=>localStorage.setItem(wishlistKey,JSON.stringify(x));
  document.querySelectorAll('[data-wishlist]').forEach(btn=>{
    const id=String(btn.dataset.productId), refresh=()=>{const on=getSaved().some(x=>String(x.id)===id);btn.classList.toggle('active',on);btn.textContent=on?'Saved to build':'Save to build'};
    btn.addEventListener('click',()=>{let list=getSaved();const i=list.findIndex(x=>String(x.id)===id);if(i>=0)list.splice(i,1);else list.push({id,title:btn.dataset.productTitle,url:location.pathname});setSaved(list);refresh()});refresh();
  });
  document.querySelectorAll('[data-vehicle-selector]').forEach(form=>form.addEventListener('submit',e=>{e.preventDefault();const d=new FormData(form);const q=[d.get('make'),d.get('model'),d.get('generation'),d.get('year')].filter(Boolean).join(' ');if(q)location.href=`/search?q=${encodeURIComponent(q)}&type=product`}));
  async function renderCart(){
    const c=await fetch('/cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(x=>x.textContent=c.item_count);
    const host=document.querySelector('[data-cart-drawer-content]'); if(!host)return;
    if(!c.items.length){host.innerHTML='<div class="empty-drawer"><p>Your garage is empty.</p><a class="btn btn-primary" href="/collections/all">Explore catalog</a></div>'}
    else host.innerHTML=c.items.map(i=>`<div class="drawer-item"><img src="${i.image||''}" alt=""><div><strong>${i.product_title}</strong><small>${i.variant_title||''}</small><span>${money(i.final_line_price,c.currency)}</span></div><button data-remove-line="${i.key}" aria-label="Remove">×</button></div>`).join('')+`<div class="drawer-subtotal"><span>Subtotal</span><strong>${money(c.total_price,c.currency)}</strong></div>`;
    const target=10000, remaining=Math.max(0,target-c.total_price), pct=Math.min(100,c.total_price/target*100);document.querySelector('[data-shipping-bar]')?.style.setProperty('width',pct+'%');const msg=document.querySelector('[data-shipping-message]');if(msg)msg.textContent=remaining?`${money(remaining,c.currency)} away from free UK delivery`:'Free UK delivery unlocked';
    host.querySelectorAll('[data-remove-line]').forEach(b=>b.addEventListener('click',async()=>{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.removeLine,quantity:0})});renderCart()}));
  }
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',renderCart));
  document.addEventListener('sette:cart-updated',renderCart); renderCart();
})();
